'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('Summary_SystemToReviewCtrl', ['$scope', '$state', 'authUser','stateAccessReview', 'authLogin', 'nbRemainingSystemsToReview', 'toRemoveEmployeeSystemRoles', function ($scope, $state, authUser,stateAccessReview, authLogin, nbRemainingSystemsToReview, toRemoveEmployeeSystemRoles) {

    if (stateAccessReview.StateName === 'Submitted' && !$state.is('accessReview.authUser.submitted') && !authUser.IsInAdministrationGroup) {
        $state.go('accessReview.authUser.submitted', null, { reload: true });
        return;
    }

    $scope.nbRemainingSystemsToReview = nbRemainingSystemsToReview.NbRemaining;
    $scope.stateAccessReview = stateAccessReview;
    $scope.nbToRemoveEmployeeSystemsRoles = toRemoveEmployeeSystemRoles.length;
    $scope.toRemoveEmployeeSystemsRoles = _.chain(toRemoveEmployeeSystemRoles)
                                           .groupBy(function (s) { return s.BusinessSystem.SystemID; })
                                           .sortBy(function (s) { return s.Name; })
                                           .value();

    $scope.continueAccessReview = function () {
        $state.go('accessReview.authUser.systemToReview',
                  { authLogin: authLogin },
                  { reload: true });
        return;
    };
}]);